import React, { useRef, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { setPBPBlockScroll } from '../../../store/reducers/mainReducer';
import PollOption from '../../Common/PollOption/PollOption';
import './RelatedStories.scss';

const RelatedStories = ({ content }) => {
  const dispatch = useDispatch();
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
  const dmnav = useSelector(state => state.data.menus.digitalMuseum);
  const linksHolderRef = useRef(null);

  // years scroll handler
  useLayoutEffect(() => {
    const ref = linksHolderRef.current;
    if (!ref) {
      return;
    }
    dispatch(setPBPBlockScroll(true));
    const handleScroll = e => {
      e.stopPropagation();
      if (ref.scrollTop <= 0 || Math.round(ref.scrollTop) >= ref.scrollHeight - ref.clientHeight) {
        setTimeout(() => dispatch(setPBPBlockScroll(false)), 500);
      } else {
        dispatch(setPBPBlockScroll(true));
      }
    };

    ref.addEventListener('scroll', handleScroll);
    return () => {
      ref.removeEventListener('scroll', handleScroll);
      dispatch(setPBPBlockScroll(false));
    };
  }, [linksHolderRef.current]);

  const handleClicked = key => {
    var match = content.Links.find(x => x.Key === key);

    switch (match.LinkType) {
      case '0':
        window.open(match.ExternalURL, '_blank');
        break;

      case '1':
        var storyKey = match.InternalURL.Menu.Key;
        var navMatch = dmnav.find(x => x.key === storyKey);
        document.location.href = navMatch.link;
        break;
    }
  };

  if (!content) {
    return null;
  }

  var links = [];
  if (content && content.Links) {
    var twoColumns = !isPortrait && content.Links.length > 4;
    for (var i = 0; i < content.Links.length; i++) {
      var link = content.Links[i];
      var key = link.Key;
      links.push(
        <div index={i} key={i} className="related-stories-row">
          {formatPollOption(key, i, isPortrait ? 'calc(100% + 10px)' : '49.5%', link)}
          {twoColumns && i + 1 < content.Links.length
            ? formatPollOption(content.Links[i + 1].Key, i + 1, '48%', content.Links[i + 1])
            : null}
        </div>
      );
      if (twoColumns) {
        i++;
      }
    }
  }

  function formatPollOption(key, i, width, link) {
    return (
      <PollOption
        dataKey={key}
        index={i}
        text={link.Name}
        height={'132px'}
        width={width}
        background={link.Background}
        buttonText={'Go'}
        choice={-1}
        tally={null}
        onClick={handleClicked}
      />
    );
  }

  return (
    <div id="related-stories">
      <div className="wrapper">
        <div className="text-holder">
          <div className="header">{content.Header}</div>
        </div>
        <div className="links-holder" ref={linksHolderRef}>
          {links}
        </div>
      </div>
    </div>
  );
};

export default RelatedStories;
